export enum EnumIconPosition {
  Left = 'left',
  Right = 'right',
}
